import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  CircularProgress,
  Typography,
  Box,
  Fade,
} from "@mui/material";

export default function LoadingModal({ open, onClose }) {
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!open) return;

    const checkConnection = () => {
      if (navigator.onLine) {
        setStatus("preparing");
      } else {
        setStatus("offline");
      }
    };

    checkConnection();
    const interval = setInterval(checkConnection, 2000);

    return () => clearInterval(interval);
  }, [open, onClose]);

  const getMessage = () => {
    switch (status) {
      case "checking":
        return "🔍 Checking internet connection...";
      case "offline":
        return "❌ You are offline. Please check your connection.";
      case "preparing":
        return "💳 Preparing payment gateway...";
      default:
        return "";
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="loading-dialog-title"
      PaperProps={{
        sx: {
          background:
            "linear-gradient(135deg, rgba(15,15,15,0.8), rgba(25,25,25,0.6))",
          backdropFilter: "blur(12px)",
          borderRadius: "20px",
          border: "1px solid rgba(255,255,255,0.15)",
          boxShadow: "0 8px 32px rgba(0,0,0,0.5)",
          p: 4,
          textAlign: "center",
        },
      }}
    >
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
          minWidth: 300,
        }}
      >
        <Box
          sx={{
            position: "relative",
            display: "inline-flex",
            "&::before": {
              content: '""',
              position: "absolute",
              top: "-8px",
              left: "-8px",
              right: "-8px",
              bottom: "-8px",
              borderRadius: "50%",
              background:
                "radial-gradient(circle, rgba(0,150,255,0.3) 0%, transparent 70%)",
              animation: "pulse 2s infinite ease-in-out",
            },
          }}
        >
          <CircularProgress
            size={60}
            thickness={5}
            sx={{ color: "rgb(0,150,255)" }}
          />
        </Box>

        <Fade in={!!status} timeout={400}>
          <Typography
            variant="subtitle1"
            key={status}
            sx={{
              color:
                status === "offline"
                  ? "#ff6b6b"
                  : status === "preparing"
                    ? "#00e676"
                    : "#e0e0e0",
              fontWeight: 500,
              letterSpacing: "0.5px",
              textAlign: "center",
              transition: "color 0.3s ease-in-out",
            }}
          >
            {getMessage()}
          </Typography>
        </Fade>
      </DialogContent>

      <style>
        {`
          @keyframes pulse {
            0% { opacity: 0.6; transform: scale(0.95); }
            50% { opacity: 1; transform: scale(1.05); }
            100% { opacity: 0.6; transform: scale(0.95); }
          }
        `}
      </style>
    </Dialog>
  );
}
